import { Layout } from "@/components/layout/Layout";
import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
const PipelineHome = lazy(() => import("@/components/pipeline/PipelineHome").then(m => ({ default: m.PipelineHome })));

const DiscoverPage = lazy(() => import("@/pages/DiscoverPage"));
const CategoryPage = lazy(() => import("@/pages/CategoryPage"));
const SearchPage = lazy(() => import("@/pages/SearchPage"));
const PromptDetailPage = lazy(() => import("@/pages/PromptDetailPage"));
const SubmitPage = lazy(() => import("@/pages/SubmitPage"));
const EditPromptPage = lazy(() => import("@/pages/EditPromptPage"));
const MySubmissionsPage = lazy(() => import("@/pages/MySubmissionsPage"));
const FavoritesPage = lazy(() => import("@/pages/FavoritesPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function RouteFallback() {
  return (
    <div
      className="flex min-h-[60vh] items-center justify-center bg-background"
      role="status"
      aria-label="Loading"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<Layout />}>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/" element={<PipelineHome />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/prompt/:id" element={<PromptDetailPage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route path="/submit" element={<SubmitPage />} />
          <Route path="/submit/:id/edit" element={<EditPromptPage />} />
          <Route path="/my-submissions" element={<MySubmissionsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
